var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.342.143a.833.833,0,0,1,1.292.7V1.918A2.856,2.856,0,0,1,8.817,4.443l-2.658.883a3.042,3.042,0,0,1-1.683,0L1.817,4.443A2.843,2.843,0,0,1,0,1.918V.835a.833.833,0,0,1,1.283-.7L3,1.251a4.206,4.206,0,0,0,2.325.658A4.206,4.206,0,0,0,7.65,1.251Z",
    transform: "translate(4.683 12.891)",
    fill: "#8963f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,3.719,9.506.444a3.259,3.259,0,0,0-3.283,0L1.206,3.719a2.655,2.655,0,0,0,0,4.45l1.333.867,3.683,2.4a3.259,3.259,0,0,0,3.283,0l3.658-2.4,1.142-.75v2.55a.625.625,0,1,0,1.25,0v-4.1A2.646,2.646,0,0,0,14.5,3.719Z",
    transform: "translate(2.152 1.664)",
    fill: "#8963f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEducation);
export default __webpack_public_path__ + "static/media/icon-education.d616b7bed0572abc537be23a9bb9835a.svg";
export { ForwardRef as ReactComponent };